import { jsx as _jsx } from "react/jsx-runtime";
export var BaseIcon = function(param) {
    var children = param.children, color = param.color, height = param.height, width = param.width;
    var colorValue = color ? "var(--cds-color-".concat(color, ")") : undefined;
    return /*#__PURE__*/ _jsx("svg", {
        height: height,
        width: width,
        color: colorValue,
        role: "img",
        "aria-hidden": true,
        focusable: false,
        children: children
    });
};
